<template>
  <main class="p20 bg-white main">
    <div class="mt20 mb20">
      <span class="title1">计费说明</span>
    </div>
    <div class="tab overflow-h">
      <!-- <span @click="changeBizTypeTab(1)" :class="{'active':this.biz_type==1}">移库换标</span>
      <span @click="changeBizTypeTab(2)" :class="{'active':this.biz_type==2}">退货质检</span> -->

      <span :class="{'active':biz_type==item.biz_type}" v-for="(item,index) in biz_types" @click="changeBizTypeTab(item.biz_type)" :key="index">{{biz_config[item.biz_type]}}</span>
    </div>

    <div class="mt50">
      <div>
        {{this.client_code == " "?"以下为账户通用报价，如需查看子账户特殊价格，请选择右上角的子账户":"以下为子账户"+(this.client_code || '')+"的报价，如需查看子账户特殊价格，请选择右上角的子账户"}}

      </div>
      <Table class="mt20" border :columns="table_data.columns" :data="table_data.data"></Table>
    </div>
  </main>
</template>

<script>
  export default {
    data() {
      return {
        biz_type: 1,
        client_code: '',
        table_data: { //列表数据
          columns: [],
          data: []
        },
        fee_type: [],
        phase: [],
        unit: [{
          value: 10,
          label: 'USD/KG'
        }, {
          value: 20,
          label: 'USD/商品'
        }, {
          value: 30,
          label: 'USD/天/商品'
        }, {
          value: 31,
          label: 'USD/天/立方米'
        }, {
          value: 40,
          label: '快递计费规则'
        }, {
          value: 50,
          label: 'USD/包裹'
        }],
        biz_types:[],
        biz_config:{ //0中转补货， 1-移库换标， 2- 退货质检， 3- PREP， 4-中转发货；
          0:'中转补货',
          1:'移库换标',
          2:'退货质检',
          3:'PREP',
          4:'中转发货',
        }
      }
    },
    methods: {
      init() {
        this.table_data.columns = this.setColumns();
        this.getTypeList();
        this.getTypeServiceList();
        this.getBiztype()
      },
      getBiztype(){ //业务类型
        this.$axios.get("/client/biz/type").then(res => {
          this.biz_types = res.data || []
          if(res.data&&res.data.length){
            this.biz_type = res.data[0].biz_type
          }
        });
      },
      changeBizTypeTab(type) {
        this.biz_type = type;
        this.getTypeList();
        this.getList();
      },
      getTypeList() {
        this.$axios.get("/fee/type/list", {
          params: {
            biz_type: this.biz_type
          }
        }).then(res => {
          this.loading = false;
          let types = [];
          if (res.success && res.data && res.data.length) {
            res.data.forEach(function(item, index) {
              let type = {};
              type.label = item.bill_type_name;
              type.value = item.bill_type_id;
              types.push(type)
            });

          }

          this.phase = types;
        })
      },
      getTypeServiceList() {
        this.$axios.get("/fee/type/service/list/all", {}).then(res => {
          this.loading = false;

          let types = [];
          if (res.success && res.data && res.data.length) {
            res.data.forEach(function(item, index) {
              let type = {};
              type.label = item.service_type_name;
              type.value = item.service_type_code;
              types.push(type)
            });
          }

          this.fee_type = types;
        })
      },
      /*
       * 获取列表
       */
      getList() {
        this.$axios.get("/fee/list", {
          params: {
            warehouse_id: this.warehouse_id,
            client_code: this.client_code,
            biz_type: this.biz_type
          }
        }).then(res => {
          if (res.success && res.data && res.data.length) {
            this.table_data.data = res.data;
          } else {
            this.table_data.data = []
          }
        })
      },
      setColumns() {
        let arr = [{
            title: '账单产生环节',
            key: 'phase',
            tooltip: true,
            minWidth: 120,
            render: (h, params) => {
              let txt = '-';
              let a = this.phase.find(item => item.value == params.row.phase)
              if (a) {
                txt = a.label
              }
              return h('span', txt)
            }
          }, {
            title: '服务类型',
            key: 'fee_type',
            tooltip: true,
            minWidth: 120,
            render: (h, params) => {
              let a = this.fee_type.find(item => item.value == params.row.fee_type)
              if (a) {
                return h('span', a.label)
              } else {
                return h('span', '-')
              }
            }
          },
          {
            title: '服务说明',
            key: 'service_desc',
            minWidth: 200,
            tooltip: true
          }, {
            title: '收费单位',
            key: 'unit',
            minWidth: 100,
            render: (h, params) => {
              let txt = '-'
              let a = this.unit.find(item => item.value == params.row.unit)
              if (a) {
                txt = a.label
              }
              return h('span', txt)
            }
          }, {
            title: '收费单价',
            key: 'unit_price',
            width: 100,
            render: (h, params) => {
              if (params.row.unit == 40) {
                return h('span', '-');
              } else {
                return h('span', '$ ' + params.row.unit_price);
              }
            }
          }, {
            title: '最低收费',
            key: 'min_price',
            minWidth: 100,
            render: (h, params) => {
              if (params.row.unit == 40) {
                return h('span', '-');
              } else {
                return h('span', '$ ' + params.row.min_price);
              }
            }
          }, {
            title: '说明',
            key: 'remark',
            minWidth: 250,
            tooltip: true
          }
        ];
        return arr;
      }
    },
    created() {
      this.init();
      this.warehouse_id = localStorage.getItem('warehouse_id')
      this.client_code = localStorage.getItem('client_code')

      if (this.warehouse_id) {
        this.getList();
      } else {
        this.$Message.info('请选择仓库')
      }
    }
  }
</script>

<style scoped="scoped">
  .tab {
    margin-top: 50px;
  }

  .tab span {
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #4f6081;
    text-align: center;
    float: left;
    cursor: pointer;
  }

  .tab .fr {
    float: right;
  }

  .tab span.active {
    background-color: #4f6081;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/charging.vue